import * as React from 'react'
import Select from 'react-select'
import { inject, observer } from 'mobx-react'
import { API, IBaseCategory } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { getCategoryName } from '../../../../../utilities/helpers'
import { BLAZE_COMPANY } from '../../../../../constants/general'

interface State {
  wooCommerceCategories: any[]
}

interface Props {
  currentUserStore: CurrentUserStore
  currentCompanyStore: CurrentCompanyStore
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class WooCommerceCategories extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      wooCommerceCategories: [],
    }
  }

  componentDidMount() {
    const company = this.props.currentCompanyStore!.company!
    this.props.currentCompanyStore!.getLocations()
    this.props.currentCompanyStore!.productStore!.getCategories()
    API.getWooCommerceCategories(company.id).then((categories) => {
      this.setState({ wooCommerceCategories: categories })
    })
  }

  updateCategory(category: IBaseCategory, wooCommerceCategoryId: number | null) {
    const company = this.props.currentCompanyStore!.company!
    const updateObject = Object.assign({}, category, {
      wooCommerceCategoryId: wooCommerceCategoryId,
    })
    API.updateCategory(company.id, category.id, updateObject).then(() => {
      this.props.currentCompanyStore!.productStore!.getCategories()
    })
  }

  render() {
    const flattenedCategories =
      this.props.currentCompanyStore!.productStore!.flattenedCategories || []

    return (
      <div className='row'>
        <div className='col-md-8'>
          <div className='alert alert-warning'>
            Connect your {BLAZE_COMPANY} categories with your WooCommerce categories.
            <br />
            Products can only be synced once their categories are connected.
          </div>
          <table className='table'>
            <thead className='thead-light'>
              <tr>
                <th>{BLAZE_COMPANY}</th>
                <th>WooCommerce</th>
                <th className='text-center'>Status</th>
              </tr>
            </thead>
            <tbody>
              {flattenedCategories.map((category) => {
                return (
                  <tr key={category.id}>
                    <td className='pr-2'>{getCategoryName(category)}</td>
                    <td style={{ width: 250 }}>
                      <Select
                        value={category.wooCommerceCategoryId}
                        clearable={true}
                        options={this.state.wooCommerceCategories.map((wooCommerceCategory) => {
                          return {
                            label: wooCommerceCategory.name,
                            value: wooCommerceCategory.id,
                          }
                        })}
                        onChange={(option: { label: string; value: number } | null) => {
                          if (option) {
                            this.updateCategory(category, option.value)
                          } else {
                            this.updateCategory(category, null)
                          }
                        }}
                      />
                    </td>
                    <td className='text-center'>
                      {category.wooCommerceCategoryId ? (
                        <span className='fa fa-circle text-success' />
                      ) : (
                        <span className='fa fa-circle text-warning' />
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
